<div class="auth-wrapper auth-v2">
  <app-language-selector></app-language-selector>

  <div class="auth-inner max-width row m-0">
    <!-- Left Text-->
    <div class="d-flex align-items-center p-5 l-side">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
        <img
          class="img-fluid"
          [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/forgot-password-v2-dark.svg'
              : 'assets/images/forgot-password.svg'
          "
          alt="Forgot password V2"
        />
      </div>
    </div>
    <!-- /Left Text-->
    <!-- Forgot password-->
    <div class="d-flex align-items-center auth-bg r-side">
      <div class="mx-auto login-form">
      <h2 class="card-title mb-1 c-company">{{'FORGOT_PASSWORD.FORM_HEADER' | translate}}</h2>
      <p class="card-text mb-2">{{'FORGOT_PASSWORD.FORM_SUBHEADER' | translate}}</p>
<!--        <p class="card-text mb-2">{{'LOGIN.FORGOT_PASSWORD' | translate}}</p>-->
        <form class="auth-forgot-password-form mt-2" [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">
          <div class="form-group">
            <label class="form-label" for="forgot-password-email">{{'FORGOT_PASSWORD.EMAIL_LABEL' | translate}}</label>
            <input
              class="form-control"
              type="text"
              id="forgot-password-email"
              formControlName="email"
              placeholder="john@example.com"
              aria-describedby="forgot-password-email"
              autofocus=""
              tabindex="1"
              [ngClass]="{ 'is-invalid': f.email.errors && (f.email.dirty || f.email.touched) }"
            />
            <div *ngIf="f.email.errors && (f.email.dirty || f.email.touched)" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">{{'FORGOT_PASSWORD.EMAIL_REQUIRED' | translate}}</div>
              <div *ngIf="f.email.errors.email|| f.email.errors.pattern">{{'FORGOT_PASSWORD.EMAIL_WRONG' | translate}}</div>
            </div>
          </div>
          <button class="btn btn-primary btn-block" [disabled]="forgotPasswordForm.invalid" tabindex="2" rippleEffect>
            <i class="fa fa-arrow-right"></i>{{'FORGOT_PASSWORD.SUBMIT' | translate}}
          </button>
        </form>
        <p class="text-center mt-2">
          <a routerLink="/{{subdomain}}/authentication/login" class="c-company"><i data-feather="chevron-left"></i>{{'FORGOT_PASSWORD.BACK_TO_LOGIN' | translate}}</a>
        </p>
      </div>
    </div>
    <!-- /Forgot password-->
  </div>
</div>
